import { css as emotionCSS } from '@emotion/react';
import Link from 'components/molecules/Link';
import { ReactNode } from 'react';
import HeaderSidebarLayout from 'components/molecules/Layout/HeaderSidebarLayout';
import AppBar from 'components/molecules/AppBar';
import Container from 'components/molecules/Container';
import MildangLogo from 'svgs/logo/MildangLogo';

const logoStyle = emotionCSS`
  width: 66px;
  height: 21.85px;
`;

const Layout = (props: { children: ReactNode }) => {
  return (
    <HeaderSidebarLayout
      header={
        <AppBar>
          <div>
            <Link href="https://study.mildang.kr" isExternal css={logoStyle}>
              <MildangLogo css={logoStyle} />
            </Link>
          </div>
        </AppBar>
      }
    >
      <Container
        maxWidth="md"
        css={emotionCSS`
          padding-top: 50px;
          padding-bottom: 50px;
          & table,
          th,
          td {
            border: 1px solid black;
            border-collapse: collapse;
          }
          & td {
            padding: 6px;
          }
        `}
      >
        {props.children}
      </Container>
    </HeaderSidebarLayout>
  );
};

export default Layout;
